// secmaster-specific helpers for the MODIFIED_DATE-checked writer. The generic
// ones (withLoadedModifiedDate, isVersionConflict, getWriteErrorMessage, ...)
// come from @1823-partners/core. Every row sent to a save carries the
// MODIFIED_DATE it was loaded with; after a 409 the UI reloads and never
// retries with a refreshed MODIFIED_DATE.
import { loadedModifiedDate } from '@1823-partners/core';

// key -> loaded token, from rows exactly as the API returned them.
export const tokensByKey = (rows, keyField) =>
  new Map(rows.map((row) => [row[keyField], loadedModifiedDate(row)]));

// Any 409 means the rows on screen are stale: reload, and keep the user's edits
// for review. Core's isVersionConflict is narrower (only the writer's
// `version_conflict`), so the reload decision uses the status alone.
export const isStaleWrite = (error) => error?.response?.status === 409;

// After a conflict reload, keep the fields the user changed (edit vs the row as
// loaded before) and take everything else from the reloaded row.
export const rebaseEdit = (edit, before, after) => {
  if (!before || !after) return edit;
  return Object.fromEntries(
    Object.keys(edit).map((field) => [
      field,
      edit[field] === before[field] ? after[field] : edit[field],
    ])
  );
};
